<template>
  <div class="addon tags" :class="[{ open: open }]">
    <div class="collapsible" @click="open = !open">
      <label>Tags</label>
      <i class="i-collapse" />
    </div>
    <InputTags
      v-model="app"
      :tags="keywords"
      :disabled="false"
      :icon_box="false"
      :full="true"
      :noUrlRedirect="true"
      :autocompleteItems="autocomplete"
      @input-tags="keywords = $event"
    />
  </div>
</template>

<script>
export default {
  name: "AddonTags",
  props: {
    content: {
      type: Object,
      default: null,
    },
    language_index: {
      type: Number,
      default: 0,
    },
    language: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    keywords: {
      handler: function (_new) {
        this.$emit("update-tags", _new);
      },
    },
  },
  data() {
    return {
      open: false,
      keywords: [],
      autocomplete: [],
    };
  },
  mounted() {
    this.keywords = this.content.categories.map((c) => {
      return { text: c.languages[0].name };
    });
    console.log(this.content.type.categories);
    this.autocomplete = this.content.type.categories.map((c) => {
      return { text: c.category.languages[0].name };
    });

    this.$emit("update-tags", this.keywords);
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/components/layout/addons.scss";
</style>
